import { shipmentInProcessValidate } from '../../application/dtos/shipment_in_process_validate';

export class shipmentInProcessEntity {
    constructor({ id, trace_id, shipments, products, process_date, shipment_type, created_at}){
        this.id = id;
        this.trace_id = trace_id;
        this.shipments = shipments;
        this.products = products;
        this.process_date = process_date;
        this.shipment_type = shipment_type;
        this.created_at = created_at;
    }

    isValid() {
        return shipmentInProcessValidate(this);
    }
}